import React, { Component } from 'react';
import { matchPath } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, TextInput, TextArea, Checkbox } from 'carbon-components-react';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import _ from 'lodash';
import { getStatusIndex } from '../../../../utils/modifiers';
import { Card } from '../../../../components';
import { getDmService, pathDmService } from '../../../../services/Api';

class Infos extends Component {
  constructor(props) {
    super(props);

    const match = matchPath(props.match.url, {
      path: '/admin/comunicacao/campanha/:id/informacoes',
    });
    const dateObj = props.data.itensCampanhaMensagem[0].datasEnvio.find(
      item => item.id.toString() === match.params.id,
    );

    this.state = {
      ...dateObj,
      admins: [],
      custoPorEnvio: dateObj.custoPorEnvio  || 0.046
    };
  }

  componentDidMount() {
    this.loadAdmins();
  }

  loadAdmins = async () => {
    try {
      const data = await getDmService('Usuario/GetAdministradores');
      this.setState({ admins: data });
    } catch (e) {
      console.log(e);
      toast.error('Ocorreu um erro ao carregar os responsáveis');
    }
  };

  onChangeText = (event, value) => {
    if (value) {
      this.setState({ [event.target.id]: value });
    } else {
      this.setState({ [event.target.id]: event.target.value });
    }
  };

  onChangeCheckbox = (id, value) => {
    this.setState({ [id]: value });
  };

  save = async () => {
    const { id } = this.state;
    const { loadCampaign } = this.props;
    const data = _.omit(this.state, 'admins');

    try {
      await pathDmService(`Pedido/AtualizaInformacoesDataEnvio/${id}`, data);
      await loadCampaign();
      toast.success('As informações da campanha foram alteradas');
    } catch (e) {
      console.log(e);
      toast.error('Ocorreu um erro ao alterar as informações da campanha');
    }
  };

  render() {
    const { data } = this.props;
    const {
      tipoDeMensagem,
      dataEnvioFormatada,
      testeABSicredi,
      admins,
      responsavelEnvio,
      areaDesenvolvimentoResponsavel,
      observacao,
      custoPorEnvio,
      custoTotal,
      quantidadeEnvios,
    } = this.state;
    const statusIndex = getStatusIndex(data.status.id);
  
    return (
      <div>
        <Card className="lg-padding">
          <div className="bx--row v-sm-margin">
            <div className="bx--col-xs-12 bx--col-sm-6">
              <label className="v-sm-margin">Tipo de Mensagem</label>
              <Select
                className="dmjob-select"
                name="tipoDeMensagem"
                options={[
                  { value: 0, label: 'Nenhum' },
                  { value: 1, label: 'Marketing' },
                  { value: 2, label: 'Corporativo' },
                ]}
                value={tipoDeMensagem}
                onChange={obj => this.setState({ tipoDeMensagem: obj.value })}
                placeholder="Selecione um tipo"
                isClearable={false}
                isSearchable={false}
                disabled={statusIndex !== 3}
              />
            </div>
          </div>
          {statusIndex >= 3 && (
            <div>
              <div className="bx--row v-sm-margin">
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <label className="v-sm-margin">Enviado em</label>
                  <TextInput id="dataEnvio" labelText="" value={dataEnvioFormatada} disabled />
                </div>
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <Checkbox
                    id="testeABSicredi"
                    className="v-lg-margin"
                    labelText="Teste A/B no Siscred"
                    onChange={value => this.onChangeCheckbox('testeABSicredi', value)}
                    checked={testeABSicredi}
                    disabled={statusIndex !== 3}
                  />
                </div>
              </div>
              <div className="bx--row v-sm-margin">
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <label className="v-sm-margin">Responsável pelo envio</label>
                  <Select
                    className="dmjob-select"
                    name="responsavelEnvio"
                    options={admins.map(item => ({
                      value: item.id,
                      label: item.sobreNome ? `${item.nome} ${item.sobreNome}` : item.nome,
                    }))}
                    value={responsavelEnvio}
                    onChange={obj => this.setState({ responsavelEnvio: obj.value })}
                    placeholder="Selecione um responsável"
                    isClearable={false}
                    disabled={statusIndex !== 3 || areaDesenvolvimentoResponsavel}
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <Checkbox
                    id="areaDesenvolvimentoResponsavel"
                    className="v-lg-margin"
                    labelText="Àrea Desenvolvimento Responsável"
                    onChange={value =>
                      this.onChangeCheckbox('areaDesenvolvimentoResponsavel', value)
                    }
                    checked={areaDesenvolvimentoResponsavel}
                    disabled={statusIndex !== 3}
                  />
                </div>
              </div>
              <div className="bx--row v-sm-margin">
                <div className="bx--col-xs-12 bx--col-sm-12">
                  <label className="v-sm-margin">Observação</label>
                  <TextArea
                    id="observacao"
                    labelText=""
                    value={observacao || ''}
                    onChange={this.onChangeText}
                    disabled={statusIndex !== 3}
                  />
                </div>
              </div>
              <div className="bx--row v-sm-margin">
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <label className="v-sm-margin">Custo por item enviado</label>
                  <NumberFormat
                    getInputRef={ref => {
                      this.custoPorEnvioRef = ref;
                    }}
                    id="custoPorEnvio"
                    className="bx--text-input bx--text__input"
                    decimalSeparator=","
                    prefix="R$ "
                    fixedDecimalScale
                    thousandSeparator="."
                    placeholder="R$ 0,00"
                    value={Number(custoPorEnvio)}
                    allowNegative={false}
                    decimalScale={3}
                    onValueChange={(values, e) => {
                      this.onChangeText(e, values.value);
                      this.setState({
                        custoTotal: values.value * Number(quantidadeEnvios),
                      });
                    }}
                    onFocus={() => {
                      if (!custoPorEnvio && this.custoPorEnvioRef) {
                        this.custoPorEnvioRef.value = '';
                      }
                    }}
                    disabled={statusIndex !== 3}
                  />
                </div>
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <label className="v-sm-margin">Custo total de envio</label>
                  <NumberFormat
                    getInputRef={ref => {
                      this.custoTotalRef = ref;
                    }}
                    id="custoTotal"
                    className="bx--text-input bx--text__input"
                    decimalSeparator=","
                    prefix="R$ "
                    fixedDecimalScale
                    thousandSeparator="."
                    placeholder="R$ 0,00"
                    value={Number(custoTotal)}
                    decimalScale={2}
                    disabled
                  />
                </div>
              </div>
              <div className="bx--row v-sm-margin">
                <div className="bx--col-xs-12 bx--col-sm-6">
                  <label className="v-sm-margin">Quantidade de Envios</label>
                  <TextInput
                    id="quantidadeEnvios"
                    type="number"
                    labelText=""
                    value={quantidadeEnvios}
                    onChange={event => {
                      this.onChangeText(event);
                      this.setState({
                        custoTotal: Number(event.target.value) * Number(custoPorEnvio),
                      });
                    }}
                    disabled={statusIndex !== 3}
                  />
                </div>
              </div>
            </div>
          )}
        </Card>
        {statusIndex === 3 && (
          <Button kind="secondary" className="full-width v-md-margin" onClick={this.save}>
            Salvar
          </Button>
        )}
      </div>
    );
  }
}

export default Infos;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/Detail/Infos.js